import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/hooks/useLang";
import { UI, BUSINESS, SERVICES, serviceUrl, serviceTitle } from "@/content/site";
import "./footer.css";

export default function Footer() {
  const lang = useLang();
  const ui = UI[lang];
  const year = new Date().getFullYear();

  return (
    <footer className="gw-footer" role="contentinfo">
      <div className="gw-container gw-footer-grid">
        <div className="gw-footer-col gw-footer-brand">
          <div className="gw-footer-logo">
            <img
              src="/images/logo.png"
              alt="Garcia-Windsor, P.C. — Attorneys · Abogados"
              className="gw-footer-logo-image"
              width="493"
              height="174"
              loading="lazy"
              decoding="async"
              data-testid="footer-logo-image"
            />
          </div>
          <p className="gw-footer-tagline">
            {lang === "en" ? BUSINESS.taglineEn : BUSINESS.taglineEs}
          </p>
          <address className="gw-footer-address">
            <a href={BUSINESS.mapUrl} target="_blank" rel="noopener noreferrer" aria-label={lang === "es" ? "Ver oficina en el mapa (abre en nueva pestaña)" : "View office on the map (opens in a new tab)"}>
              {BUSINESS.street}<br />
              {BUSINESS.city}, {BUSINESS.state} {BUSINESS.postal}
            </a>
            <a href={`tel:${BUSINESS.phoneTel}`} className="gw-footer-phone" aria-label={lang === "es" ? `Llamar a Garcia-Windsor al ${BUSINESS.phoneDisplay}` : `Call Garcia-Windsor at ${BUSINESS.phoneDisplay}`}>
              {BUSINESS.phoneDisplay}
            </a>
            <div className="gw-footer-hours">{ui.officeHoursFull.split("\n").map((h) => <div key={h}>{h}</div>)}</div>
          </address>
        </div>

        <nav className="gw-footer-col" aria-label={ui.footerFamilyLaw}>
          <h4>{ui.footerFamilyLaw}</h4>
          <ul>
            {SERVICES.map((s) => (
              <li key={s.key}>
                <Link to={serviceUrl(s, lang)}>{serviceTitle(s, lang)}</Link>
              </li>
            ))}
            <li><Link to={ui.businessLawUrl}>{ui.navBusinessLaw}</Link></li>
          </ul>
        </nav>

        <nav className="gw-footer-col" aria-label={ui.footerFirm}>
          <h4>{ui.footerFirm}</h4>
          <ul>
            <li><Link to={ui.aboutUrl}>{ui.navAbout}</Link></li>
            <li><Link to={ui.isabelaUrl}>Isabela A. Garcia</Link></li>
            <li><Link to={ui.andrewUrl}>Andrew Jee</Link></li>
            <li><Link to={ui.testimonialsUrl}>{ui.navTestimonials}</Link></li>
            <li><Link to={ui.pressUrl}>{ui.navPress}</Link></li>
            <li><Link to={ui.resourcesUrl}>{lang === "en" ? "Forms & Resources" : "Formularios y Recursos"}</Link></li>
            <li><Link to={ui.blogUrl}>{ui.navBlog}</Link></li>
            <li><Link to={ui.locationsUrl}>{lang === "en" ? "Locations" : "Ubicaciones"}</Link></li>
            <li><Link to={ui.contactUrl}>{ui.navContact}</Link></li>
          </ul>
        </nav>

        <div className="gw-footer-col">
          <h4>{ui.footerConnect}</h4>
          <ul className="gw-footer-social">
            <li><a href={BUSINESS.social.instagram} target="_blank" rel="noopener noreferrer" aria-label={lang === "es" ? "Instagram (abre en nueva pestaña)" : "Instagram (opens in a new tab)"}>Instagram</a></li>
            <li><a href={BUSINESS.social.facebook} target="_blank" rel="noopener noreferrer" aria-label={lang === "es" ? "Facebook (abre en nueva pestaña)" : "Facebook (opens in a new tab)"}>Facebook</a></li>
            <li><a href={BUSINESS.social.tiktok} target="_blank" rel="noopener noreferrer" aria-label={lang === "es" ? "TikTok (abre en nueva pestaña)" : "TikTok (opens in a new tab)"}>TikTok</a></li>
            <li><a href={BUSINESS.social.youtube} target="_blank" rel="noopener noreferrer" aria-label={lang === "es" ? "YouTube (abre en nueva pestaña)" : "YouTube (opens in a new tab)"}>YouTube</a></li>
            <li><a href={BUSINESS.social.x} target="_blank" rel="noopener noreferrer" aria-label={lang === "es" ? "X (abre en nueva pestaña)" : "X (opens in a new tab)"}>X</a></li>
            <li><a href={BUSINESS.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label={lang === "es" ? "LinkedIn (abre en nueva pestaña)" : "LinkedIn (opens in a new tab)"}>LinkedIn</a></li>
          </ul>
          <p className="gw-footer-consulate">
            {lang === "en"
              ? "Exclusive Consulting Attorney — Mexican Consulate General of Dallas (PALE Program)"
              : "Abogada Consultora Exclusiva — Consulado General de México en Dallas (Programa PALE)"}
          </p>
        </div>
      </div>

      <div className="gw-container gw-footer-bottom">
        <p className="gw-footer-copyright">© {year} Garcia-Windsor, P.C. {lang === "en" ? "All rights reserved." : "Todos los derechos reservados."}</p>
        <ul className="gw-footer-legal">
          <li><Link to={ui.privacyUrl}>{ui.privacy}</Link></li>
          <li><Link to={ui.termsUrl}>{ui.terms}</Link></li>
        </ul>
      </div>
      <div className="gw-container">
        <p className="gw-footer-disclaimer">
          <small>{ui.attorneyAd}</small>
        </p>
        <p className="gw-footer-credit">
          <small>
            <a
              href="https://digitalmedianinja.com/services/web-design"
              target="_blank"
              rel="noopener"
              data-testid="design-credit-link"
              aria-label={lang === "es"
                ? "Diseño Web en Dallas por Digital Media Ninja (abre en nueva pestaña)"
                : "Dallas Web Design by Digital Media Ninja (opens in a new tab)"}
            >
              {lang === "es"
                ? "Diseño Web en Dallas por Digital Media Ninja"
                : "Dallas Web Design by Digital Media Ninja"}
            </a>
          </small>
        </p>
      </div>
    </footer>
  );
}
